export const SET_USER_DETAILS_DATA = 'SET_USER_DETAILS_DATA';
export const SET_PARTNER_NAME = 'SET_PARTNER_NAME';
